import { Notification, NotificationType } from '../types/notification';

// Chave para armazenar notificações no localStorage
const NOTIFICATIONS_STORAGE_KEY = 'notifications';

// Função para carregar notificações do localStorage
const loadNotifications = (): Notification[] => {
  try {
    const storedNotifications = localStorage.getItem(NOTIFICATIONS_STORAGE_KEY);
    return storedNotifications ? JSON.parse(storedNotifications) : [];
  } catch (error) {
    console.error('Erro ao carregar notificações:', error);
    return [];
  }
};

// Função para salvar notificações no localStorage
const saveNotifications = (notifications: Notification[]): void => {
  try {
    localStorage.setItem(NOTIFICATIONS_STORAGE_KEY, JSON.stringify(notifications));
  } catch (error) {
    console.error('Erro ao salvar notificações:', error);
  }
};

const notificationService = {
  getNotifications: (): Notification[] => {
    return loadNotifications();
  },

  createNotification: (notification: Omit<Notification, 'id' | 'createdAt' | 'read'>): Notification => {
    const notifications = loadNotifications();
    const newNotification: Notification = {
      ...notification,
      id: Math.random().toString(36).substr(2, 9),
      createdAt: new Date().toISOString(),
      read: false,
    };
    saveNotifications([newNotification, ...notifications]);
    return newNotification;
  },

  markAsRead: (id: string): void => {
    const notifications = loadNotifications();
    const updatedNotifications = notifications.map(notification =>
      notification.id === id ? { ...notification, read: true } : notification
    );
    saveNotifications(updatedNotifications);
  },

  markAllAsRead: (): void => {
    const notifications = loadNotifications();
    const updatedNotifications = notifications.map(notification => ({
      ...notification,
      read: true,
    }));
    saveNotifications(updatedNotifications);
  },

  deleteNotification: (id: string): void => {
    const notifications = loadNotifications();
    const updatedNotifications = notifications.filter(
      notification => notification.id !== id
    );
    saveNotifications(updatedNotifications);
  },

  deleteAllNotifications: (): void => {
    saveNotifications([]);
  },

  getUnreadCount: (): number => {
    const notifications = loadNotifications();
    return notifications.filter(notification => !notification.read).length;
  },
};

export default notificationService; 